/**
 * Peças comuns das seções da tela Cadastros.
 *
 * Lê: nada.
 * Usado por: telas/Cadastros.tsx e telas/cadastros/*.tsx.
 */
import type { PeriodoDaLigacao } from '../../dominio/identificacao.ts';
import type { Cadastros, Representante } from '../../dominio/tipos.ts';
import { mesAbreviado } from '../../formatacao.ts';

/** Roda uma ação na API, troca os cadastros pelos que voltaram e mostra a mensagem. Devolve true se deu certo. */
export type Executar = (acao: () => Promise<Cadastros>, sucesso: string) => Promise<boolean>;

export const porNome = (a: Representante, b: Representante) => a.nome.localeCompare(b.nome, 'pt-BR');

/** "desde sempre", "até ago/2026", "desde set/2026" ou "set/2026 a nov/2026". */
export function descreverPeriodo(ligacao: PeriodoDaLigacao): string {
  if (ligacao.desde === null) return ligacao.ate === null ? 'desde sempre' : `até ${mesAbreviado(ligacao.ate)}`;
  return ligacao.ate === null ? `desde ${mesAbreviado(ligacao.desde)}` : `${mesAbreviado(ligacao.desde)} a ${mesAbreviado(ligacao.ate)}`;
}
